import script from "./PermissionProfiles.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionProfiles.vue?vue&type=script&setup=true&lang=js"

import "./PermissionProfiles.vue?vue&type=style&index=0&id=428ca00f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428ca00f"]])

export default __exports__